import { createFileRoute, notFound } from '@tanstack/react-router';

import { APP_ID } from '@/features/app-integration/constant';
import { apiClient } from '@/lib/api/client';

export const Route = createFileRoute(
  '/_staff/software/_layout/marketplace/$id',
)({
  loader: async ({ params }) => {
    if (params.id === APP_ID.CUSTOM_APP) {
      throw notFound();
    }
    const res = await apiClient.GET('/v2/apps/{id}', {
      params: { path: { id: params.id } },
    });
    if (!res.data) throw notFound();

    return res.data;
  },
});
